<template>
  <div class="p-4">
    <!-- Кнопка "Назад" -->
    <div class="flex justify-start mb-4">
      <button
        @click="goBack"
        class="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-200 rounded-md hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-gray-500"
      >
        Назад
      </button>
    </div>

    <h1 class="text-xl font-bold mb-4">Редактирование модуля</h1>
    <form @submit.prevent="submitForm">
      <div class="mb-4">
        <label class="block text-sm font-medium text-gray-700 mb-1">Название</label>
        <input
          v-model="formData.name"
          type="text"
          required
          class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          placeholder="Введите название модуля"
        />
      </div>

      <!-- Пользователи модуля: только для чтения, доступ задаётся ролью -->
      <div class="mb-4">
        <label class="block text-sm font-medium text-gray-700 mb-1">Доступ</label>
        <p class="text-xs text-gray-500 mb-2">Доступ задаётся ролью</p>
        <div v-if="loading" class="flex justify-center items-center h-10">
          <div class="animate-spin rounded-full h-6 w-6 border-t-2 border-b-2 border-blue-500"></div>
        </div>
        <ul v-else-if="users.length" class="text-sm text-gray-700 space-y-1">
          <li v-for="user in users" :key="user.id">{{ userTitle(user) }}</li>
        </ul>
        <p v-else class="text-sm text-gray-500">Доступ к модулю не выдан ни одной роли</p>
      </div>

      <!-- Чекбоксы дочерних модулей -->
      <div class="mb-4">
        <label class="block text-sm font-medium text-gray-700 mb-1">Дочерние модули</label>
        <div v-if="loadingModules" class="flex justify-center items-center h-10">
          <div class="animate-spin rounded-full h-6 w-6 border-t-2 border-b-2 border-blue-500"></div>
        </div>
        <div v-else v-for="module in allModules" :key="module.id" class="flex items-center space-x-2">
          <input
            v-model="formData.child_modules"
            type="checkbox"
            :value="module.id"
            class="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
          />
          <span>{{ module.name }}</span>
        </div>
      </div>

      <!-- Кнопка сохранения -->
      <div class="flex justify-end space-x-2">
        <button
          v-can-write="'modules'"
          type="submit"
          class="px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
        >
          Сохранить
        </button>
      </div>
    </form>
  </div>
</template>

<script>
export default {
  data() {
    return {
      formData: {
        name: '',
        child_modules: [], // ID выбранных дочерних модулей
      },
      users: [], // Пользователи модуля (только для чтения, набор задаётся ролями)
      allModules: [], // Список всех модулей
      loading: true, // Флаг загрузки данных модуля
      loadingModules: true, // Флаг загрузки модулей
    };
  },
  created() {
    this.fetchModuleDetails();
    this.fetchAllModules();
  },
  methods: {
    fetchModuleDetails() {
      const moduleId = this.$route.params.id; // Получаем ID из URL
      axios
        .post('/api/module/getModule', { id: moduleId })
        .then((response) => {
          const moduleData = response.data.data;
          this.formData.name = moduleData.name;
          this.formData.module_type_id = moduleData.module_type_id;

          // Пользователи модуля показываются списком: их набор пересобирается из матрицы роли
          this.users = moduleData.users || [];

          // Преобразуем массив дочерних модулей в массив их ID
          this.formData.child_modules = moduleData.child_modules.map(child => child.id);

          this.loading = false;
        })
        .catch((error) => {
          console.error('Ошибка при загрузке данных модуля:', error);
          this.loading = false;
        });
    },
    /**
     * Подпись пользователя в списке доступа: логин и роль, если она пришла.
     */
    userTitle(user) {
      const roleName = user.role?.name || user.role;

      return roleName ? `${user.name} — ${roleName}` : user.name;
    },
    fetchAllModules() {
      axios
        .post('/api/module/getModules')
        .then((response) => {
          this.allModules = response.data.data; // Сохраняем список всех модулей
          this.loadingModules = false;
        })
        .catch((error) => {
          console.error('Ошибка при загрузке модулей:', error);
          this.loadingModules = false;
        });
    },
    submitForm() {
      axios
        .post('/api/module/createOrUpdateModule', {
          id: this.$route.params.id,
          ...this.formData,
        })
        .then(() => {
          this.goBack();
        })
        .catch((error) => {
          console.error(error);
        });
    },
    goBack() {
      this.$router.back(); // Возвращаемся на предыдущую страницу
    },
  },
};
</script>
